import Storage from 'utils/localStorage/Storage';

async function updateCache(key, params, reducer, { ttl = null, defaultValue = { skus: [] } } = {}) {
    const LOVES_DATA_EXPIRY = Storage.MINUTES * 15;

    // 1) read old state from IndexedDB, checking TTL expiry
    const oldStateWrapper = await Storage.db.getItem(key, false, false, true); // returnDataWithExpiry = true
    let oldState;
    let isExpired = false;

    // 2) check if data has expired
    if (oldStateWrapper && typeof oldStateWrapper === 'object') {
        if (oldStateWrapper.expiry) {
            isExpired = Date.parse(oldStateWrapper.expiry) < new Date().getTime();
        }

        oldState = oldStateWrapper.data || oldStateWrapper; // extract the actual data
    } else {
        oldState = oldStateWrapper;
    }

    // 3) normalize if missing/invalid/expired
    if (!oldState || typeof oldState !== 'object' || isExpired) {
        oldState = defaultValue;
    }

    // 4) compute next state via your reducer (pure function)
    const nextState = typeof reducer === 'function' ? reducer(oldState, params) : params;

    // 5) write back (with optional TTL, or preserve existing TTL if not expired)
    if (ttl != null) {
        await Storage.db.setItem(key, nextState, ttl);
    } else {
        // Always refresh expiry with a new TTL when ttl: null is passed
        // This gives users a fresh window every time they interact with the list

        await Storage.db.setItem(key, nextState, LOVES_DATA_EXPIRY);
    }

    // 6) return the updated value and expiry status
    return { ...nextState, _wasExpired: isExpired };
}

export default updateCache;
